import React from "react";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import "../Css/Contact.css";

export function Contact() {

    const user = "contact";
    const domain = "smarttasksoftware.com";
    const email = `${user}@${domain}`;

    const handleContactClick = (url: string,platform:string) => {
        if(!window.confirm(platform === 'whatsapp' ? "Open WhatsApp to start chatting with us?" : "Open email to send us a message?")) {
            return;
        }
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="contact-container">
            <div className="contact-left">
                <h1>Contact</h1>
                <div className="contact-heading">
                    <p>
                        Navigating life's intricate fabric, choices unfold paths to the
                        extraordinary, demanding creativity, curiosity, and courage for a
                        truly fulfilling journey.
                    </p>
                </div>
                <div className="contact-methods">
                    <div className="contact-email">
                        <EmailIcon className="contact-email-icon" />
                        <a
                            href={`mailto:${email}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleContactClick(
                                    `mailto:${email}?subject=${encodeURIComponent("Project Inquiry")}`,'gmail'
                                );
                            }}
                        >
                            {email}
                        </a>
                    </div>
                    <Button
                        variant="contained"
                        className="contact-whatsapp"
                        onClick={() =>
                            handleContactClick("https://wa.me/40775664429",'whatsapp')
                        }
                        startIcon={<WhatsAppIcon />}
                    >
                        Chat with us
                    </Button>
                </div>
            </div>
            <div className="contact-right">
                <img src="/images/contact-mail.png" alt="Contact Visual" />
            </div>
        </div>
    );
}
